// extracted by mini-css-extract-plugin
module.exports = {"special-promo":"a10a3f92e9--special-promo--sW3ab","logo":"a10a3f92e9--logo--chwPf"};